/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_Plan_WriteInputs */

const en_inbox_na_plan_write = /** @type {(inputs: Inbox_Na_Plan_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write the plan`)
};

const id_inbox_na_plan_write = /** @type {(inputs: Inbox_Na_Plan_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulis rencana`)
};

/**
* | output |
* | --- |
* | "Write the plan" |
*
* @param {Inbox_Na_Plan_WriteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_plan_write = /** @type {((inputs?: Inbox_Na_Plan_WriteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Plan_WriteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_plan_write(inputs)
	return en_inbox_na_plan_write(inputs)
});